import { Icon } from '@codeparva/ui-components-library';
import React from 'react';
import { FaChevronDown } from '@react-icons/all-files/fa/FaChevronDown';
import { LocationTypes } from '../locationTypes';
import { FormattedHrs } from './FormattedHrs';
import {
  getClassNameFromTheme,
  getIconColorFromTheme,
} from '../helpers/colorSelectionTheme';

export const FacilityHrs = ({
  show,
  onFacilityHrsToggle,
  formattedHrs,
  theme,
}: LocationTypes.IFacilityHrs) => {
  if (show) {
    return (
      <FormattedHrs
        onFacilityHrsToggle={onFacilityHrsToggle}
        formattedHrs={formattedHrs}
        show="both"
        theme={theme}
        titleClassName="subtitle1"
      />
    );
  }
  return (
    <p className={getClassNameFromTheme(theme)} onClick={onFacilityHrsToggle}>
      Click here to view facility & gate hours
      <span>
        <Icon
          color={getIconColorFromTheme(theme)}
          renderAs="span"
          title="Click to expand facility and gate hours"
        >
          <FaChevronDown size={8} />
        </Icon>
      </span>
    </p>
  );
};
